export default __webpack_public_path__ + "static/ban2-a9856028617d419155fe3288a657ab77.png";